import React from 'react';
import RequireEvent from '../../components/RequireEvent';
import { choose } from '../../utils/platform';
import { useReminders } from './useReminders';
import RemindersDesktop from './Reminders.desktop';
import RemindersMobile from './Reminders.mobile';
import '../../styles/people.css';

const RemindersView = choose(RemindersDesktop, RemindersMobile);

function RemindersInner({ event }) {
  const vm = useReminders(event);
  return <RemindersView vm={vm} />;
}

export default function Reminders() {
  return <RequireEvent>{(event) => <RemindersInner event={event} />}</RequireEvent>;
}
